import { ActionParams } from './actions';
import { TranslationsMap } from '@src/types';
import { checkPendingChanges } from './save-status';

export const updateTranslations = (actionParams: ActionParams) => async (newTranslations: Partial<TranslationsMap>) => {
  const { getState, setState } = actionParams;
  const { pendingState } = getState();
  if (!pendingState) {
    return;
  }
  await setState({
    pendingState: {
      appSettings: {
        ...pendingState.appSettings,
        texts: {
          ...pendingState.appSettings.texts,
          ...newTranslations,
        },
      },
    },
  });

  await checkPendingChanges(actionParams)();
};
